export type IDisplayJsonErrors = (errorObj: IDCA.IGenericObj, suffix?: string) => void;

export function displayJsonErrors(errorObj: IDCA.IGenericObj, suffix?: string): void {
  if (!errorObj) {
    return;
  }
  // Suffix exists in global scope, if we want to override suttix, pass into the function as second paramter
  let _suffix = typeof window.fieldSuffix !== 'undefined' ? window.fieldSuffix : '';
  if (suffix) {
    _suffix = suffix;
  }
  $.each(errorObj.errors, (_, err) => {
    if (err.warning) {
      window.DexeroCoreApp.showFormGroupWarning($(`#${err.fieldName}${_suffix}`), err.errorMsg);
    } else {
      window.DexeroCoreApp.showFormGroupError($(`#${err.fieldName}${_suffix}`), err.errorMsg);
    }
  });
}
